/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './starterpack.defs.js'
export * as $defs from './starterpack.defs.js'
